import React, { useEffect, useState } from "react";
import { API_BASE } from "../config/api";

import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

function HomeConfigPanel() {
    const [homeMode, setHomeMode] = useState("default");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const loadHomeConfig = async () => {
        try {
            setLoading(true);

            const response = await fetch(`${API_BASE}/api/admin/widgets/home-config`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener la configuración");
            }

            setHomeMode(data?.data?.HomeConfig_Modo || "default");
        } catch (error) {
            console.error("Error cargando configuración del home:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            setSaving(true);

            const response = await fetch(`${API_BASE}/api/admin/widgets/home-config`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    home_mode: homeMode,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible guardar la configuración");
            }

            alert("Configuración guardada correctamente");
        } catch (error) {
            console.error("Error guardando configuración:", error);
            alert(error.message || "Ocurrió un error");
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => {
        loadHomeConfig();
    }, []);

    // Terminos y Condiciones 
    const [tycList, setTycList] = useState([]);
    const [loadingTyc, setLoadingTyc] = useState(false);
    const [savingTyc, setSavingTyc] = useState(false);

    const [selectedTyc, setSelectedTyc] = useState(null);
    const [loadingTycDetail, setLoadingTycDetail] = useState(false);
    const [updatingTyc, setUpdatingTyc] = useState(false);

    const [editTycForm, setEditTycForm] = useState({
        tycId: "",
        titulo: "",
        regionId: "",
        html: "",
        docx: null,
        mode: "editor",
    });

    const [tycForm, setTycForm] = useState({
        titulo: "",
        regionId: "",
        html: "",
        docx: null,
        mode: "editor", // editor | docx
    });

    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["link"],
            ["clean"],
        ],
    };

    const quillFormats = [
        "header",
        "bold",
        "italic",
        "underline",
        "list",
        "bullet",
        "indent",
        "link",
    ];

    const loadTyCList = async () => {
        try {
            setLoadingTyc(true);

            const res = await fetch(`${API_BASE}/api/admin/tyc`, {
                method: "GET",
                credentials: "include",
            });

            const data = await res.json();

            if (!res.ok || !data.ok) {
                throw new Error(data.message || "Error al cargar TyC");
            }

            setTycList(data.tyc || []);
        } catch (error) {
            console.error("Error cargando TyC:", error);
            setTycList([]);
        } finally {
            setLoadingTyc(false);
        }
    };

    useEffect(() => {
        loadTyCList();
    }, []);

    // Helpers
    const formatDateMexico = (date) => {
        if (!date) return "Sin fecha";

        const cleanDate = typeof date === "string"
            ? date.replace(" ", "T")
            : date;

        return new Intl.DateTimeFormat("es-MX", {
            timeZone: "America/Mexico_City",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
        }).format(new Date(cleanDate));
    };

    // Funcion para Crear TyC
    const handleCreateTyC = async (e) => {
        e.preventDefault();

        try {
            setSavingTyc(true);

            if (!tycForm.titulo || !tycForm.regionId) {
                alert("El título y la región son obligatorios");
                return;
            }

            const formData = new FormData();

            formData.append("titulo", tycForm.titulo);
            formData.append("regionId", tycForm.regionId);

            if (tycForm.mode === "editor") {
                if (!tycForm.html || tycForm.html === "<p><br></p>") {
                    alert("Debes escribir el contenido de los términos y condiciones");
                    return;
                }

                formData.append("html", tycForm.html);
                formData.append("mode", "editor");
            }

            if (tycForm.mode === "docx") {
                if (!tycForm.docx) {
                    alert("Debes seleccionar un archivo .docx");
                    return;
                }

                formData.append("docx", tycForm.docx);
                formData.append("mode", "docx");
            }

            const res = await fetch(`${API_BASE}/api/admin/tyc`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await res.json();

            if (!res.ok || !data.ok) {
                throw new Error(data.message || "Error al guardar TyC");
            }

            setTycForm({
                titulo: "",
                regionId: "",
                html: "",
                docx: null,
                mode: "editor",
            });

            await loadTyCList();

            alert("TyC creado correctamente");
        } catch (error) {
            console.error("Error creando TyC:", error);
            alert(error.message || "Error al crear TyC");
        } finally {
            setSavingTyc(false);
        }
    }; 

    // Funcion para ver TyC
    const handleViewTyC = async (tycId) => {
        try {
            setLoadingTycDetail(true);
            setSelectedTyc(null);

            const res = await fetch(`${API_BASE}/api/admin/tyc/${tycId}`, {
                method: "GET",
                credentials: "include",
            });

            const data = await res.json();

            if (!res.ok || !data.ok) {
                throw new Error(data.message || "Error al obtener detalle del TyC");
            }

            setSelectedTyc(data.tyc);
        } catch (error) {
            console.error("Error viendo TyC:", error);
            alert(error.message || "Error al obtener detalle del TyC");
        } finally {
            setLoadingTycDetail(false);
        }
    };

    // Funcion para editar TyC
const getTycPayload = (data) => {
    return data?.tyc || data?.data || data?.result || null;
};

// Funcion para editar TyC
const handleOpenEditTyC = async (item) => {
    const fallbackId = item?.TyC_ID;

    if (!fallbackId) {
        console.error("Item sin TyC_ID:", item);
        alert("No se encontró el ID del TyC seleccionado");
        return;
    }

    // Primero llena el modal con lo que ya trae la tabla
    setEditTycForm({
        tycId: fallbackId,
        titulo: item?.TyC_Titulo || "",
        regionId: String(item?.TyC_Region_ID || ""),
        html: item?.TyC_HTML || "",
        docx: null,
        mode: "editor",
    });

    try {
        setLoadingTycDetail(true);

        const res = await fetch(`${API_BASE}/api/admin/tyc/${fallbackId}`, {
            method: "GET",
            credentials: "include",
        });

        const data = await res.json();

        if (!res.ok || !data.ok) {
            throw new Error(data.message || "Error al obtener TyC");
        }

        const tyc = getTycPayload(data);

        if (!tyc) {
            throw new Error("El backend no regresó información del TyC");
        }

        setEditTycForm({
            tycId: tyc.TyC_ID || fallbackId,
            titulo: tyc.TyC_Titulo || item?.TyC_Titulo || "",
            regionId: String(tyc.TyC_Region_ID || item?.TyC_Region_ID || ""),
            html: tyc.TyC_HTML || item?.TyC_HTML || "",
            docx: null,
            mode: "editor",
        });

    } catch (error) {
        console.error("Error cargando TyC para editar:", error);
        alert(error.message || "Error al cargar TyC para editar");
    } finally {
        setLoadingTycDetail(false);
    }
};

    const handleUpdateTyC = async (e) => {
        e.preventDefault();

        try {
            setUpdatingTyc(true);

            if (!editTycForm.tycId) {
                console.error("editTycForm sin ID:", editTycForm);
                alert("No se encontró el ID del TyC a actualizar");
                return;
            }

            if (!editTycForm.titulo || !editTycForm.regionId) {
                alert("El título y la región son obligatorios");
                return;
            }

            const formData = new FormData();

            formData.append("titulo", editTycForm.titulo);
            formData.append("regionId", editTycForm.regionId);
            formData.append("mode", editTycForm.mode);

            if (editTycForm.mode === "editor") {
                if (!editTycForm.html || editTycForm.html === "<p><br></p>") {
                    alert("Debes escribir el contenido de los términos y condiciones");
                    return;
                }

                formData.append("html", editTycForm.html);
            }

            if (editTycForm.mode === "docx") {
                if (!editTycForm.docx) {
                    alert("Debes seleccionar un archivo .docx");
                    return;
                }

                formData.append("docx", editTycForm.docx);
            }

            const res = await fetch(`${API_BASE}/api/admin/tyc/${editTycForm.tycId}`, {
                method: "PUT",
                credentials: "include",
                body: formData,
            });

            const data = await res.json();

            if (!res.ok || !data.ok) {
                throw new Error(data.message || "Error al actualizar TyC");
            }

            await loadTyCList();

            alert("TyC actualizado correctamente");
        } catch (error) {
            console.error("Error actualizando TyC:", error);
            alert(error.message || "Error al actualizar TyC");
        } finally {
            setUpdatingTyc(false);
        }
    };

    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>

            <div class="content-inner container-fluid pb-0" id="page_layout">
                <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
                    <div class="d-flex flex-column">
                        <h3>Switch Home </h3>
                        <p class="text-primary mb-0">Panduit Core</p>
                    </div>
                </div>

                 {/* Configuracion del Home */}
                <div className="card">
                    <div className="card-body">
                        <h4>Configuración del Home</h4>

                        {loading ? (
                            <>
                            <div className="col-md-12 col-sm-4 mb-4">
                                <div className="iq-loader-box">
                                    <div className="iq-loader-1"></div>
                                </div>
                            </div>
                            <p>Cargando configuración...</p>
                            </>
                        ) : (
                            <>
                                <div className="mb-3">
                                    <label className="form-label">Modo del Home</label>
                                    <select
                                        className="form-select"
                                        value={homeMode}
                                        onChange={(e) => setHomeMode(e.target.value)}
                                        disabled={saving}
                                    >
                                        <option value="default">Home normal</option>
                                        <option value="launch">Home lanzamiento</option>
                                        <option value="maintenance">Home mantenimiento</option>
                                    </select>
                                </div>

                                <button
                                    className="btn btn-primary"
                                    onClick={handleSave}
                                    disabled={saving}
                                >
                                    {saving ? "Guardando..." : "Guardar"}
                                </button>
                            </>
                        )}
                    </div>
                </div>

                {/* Lista de TyC */}
                <div className="card">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card">
                                <div className="card-header d-flex justify-content-end">
                                    <div className="row g-2 align-items-end w-100">
                                        <div className="col-md-4">
                                            <h4>Terminos y Condiciones</h4>
                                        </div>

                                        <div className="col-md-3 d-flex justify-content-end gap-2 ms-auto">
                                            <button
                                                type="button"
                                                className="btn btn-secondary-subtle btn-sm"
                                                title="Limpiar filtros"
                                            >
                                                <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.4">
                                                    <path
                                                        d="M4.88076 14.6713C4.74978 14.2784 4.32504 14.066 3.93208 14.197C3.53912 14.328 3.32675 14.7527 3.45774 15.1457L4.88076 14.6713ZM20.8808 15.1457C21.0117 14.7527 20.7994 14.328 20.4064 14.197C20.0135 14.066 19.5887 14.2784 19.4577 14.6713L20.8808 15.1457ZM4.16925 14.9085C3.45774 15.1457 3.45785 15.146 3.45797 15.1464C3.45802 15.1465 3.45815 15.1469 3.45825 15.1472C3.45845 15.1478 3.45868 15.1485 3.45895 15.1493C3.45948 15.1509 3.46013 15.1528 3.46092 15.1551C3.46249 15.1597 3.46456 15.1657 3.46716 15.1731C3.47235 15.188 3.47961 15.2084 3.48902 15.2341C3.50782 15.2854 3.53521 15.3576 3.5717 15.4477C3.64461 15.6279 3.7542 15.8805 3.90468 16.1814C4.2048 16.7817 4.67223 17.5836 5.34308 18.3886C6.68942 20.0043 8.88343 21.6585 12.1693 21.6585V20.1585C9.45507 20.1585 7.64908 18.8128 6.49542 17.4284C5.91627 16.7334 5.5087 16.0354 5.24632 15.5106C5.11555 15.2491 5.02201 15.0329 4.96212 14.8849C4.9322 14.811 4.91076 14.7543 4.89733 14.7177C4.89062 14.6994 4.88593 14.6861 4.88318 14.6783C4.88181 14.6744 4.88093 14.6718 4.88053 14.6706C4.88033 14.67 4.88025 14.6698 4.88029 14.6699C4.88031 14.67 4.88036 14.6701 4.88044 14.6704C4.88047 14.6705 4.88056 14.6707 4.88058 14.6708C4.88067 14.671 4.88076 14.6713 4.16925 14.9085ZM12.1693 21.6585C15.4551 21.6585 17.6491 20.0043 18.9954 18.3886C19.6663 17.5836 20.1337 16.7817 20.4338 16.1814C20.5843 15.8805 20.6939 15.6279 20.7668 15.4477C20.8033 15.3576 20.8307 15.2854 20.8495 15.2341C20.8589 15.2084 20.8662 15.188 20.8713 15.1731C20.8739 15.1657 20.876 15.1597 20.8776 15.1551C20.8784 15.1528 20.879 15.1509 20.8796 15.1493C20.8798 15.1485 20.8801 15.1478 20.8803 15.1472C20.8804 15.1469 20.8805 15.1465 20.8805 15.1464C20.8807 15.146 20.8808 15.1457 20.1693 14.9085C19.4577 14.6713 19.4578 14.671 19.4579 14.6708C19.4579 14.6707 19.458 14.6705 19.4581 14.6704C19.4581 14.6701 19.4582 14.67 19.4582 14.6699C19.4583 14.6698 19.4582 14.67 19.458 14.6706C19.4576 14.6718 19.4567 14.6744 19.4553 14.6783C19.4526 14.6861 19.4479 14.6994 19.4412 14.7177C19.4277 14.7543 19.4063 14.811 19.3764 14.8849C19.3165 15.0329 19.223 15.2491 19.0922 15.5106C18.8298 16.0354 18.4222 16.7334 17.8431 17.4284C16.6894 18.8128 14.8834 20.1585 12.1693 20.1585V21.6585Z"
                                                        fill="currentColor"></path>
                                                    <path d="M21.5183 19.2271C21.4293 19.2234 21.3427 19.196 21.2671 19.1465L16.3546 15.8924C16.2197 15.8026 16.1413 15.6537 16.148 15.4969C16.1546 15.34 16.2452 15.1982 16.3873 15.1202L21.5571 12.2926C21.7075 12.2106 21.8932 12.213 22.0416 12.3003C22.1907 12.387 22.2783 12.5436 22.2712 12.7096L22.014 18.7913C22.007 18.9573 21.9065 19.1059 21.7506 19.1797C21.6772 19.215 21.597 19.2305 21.5183 19.2271" fill="currentColor"></path>
                                                    </g>
                                                    <path
                                                    d="M20.0742 10.0265C20.1886 10.4246 20.6041 10.6546 21.0022 10.5401C21.4003 10.4257 21.6302 10.0102 21.5158 9.61214L20.0742 10.0265ZM4.10803 8.88317C3.96071 9.27031 4.15513 9.70356 4.54226 9.85087C4.92939 9.99818 5.36265 9.80377 5.50996 9.41664L4.10803 8.88317ZM20.795 9.81934C21.5158 9.61214 21.5157 9.6118 21.5156 9.61144C21.5155 9.61129 21.5154 9.6109 21.5153 9.61059C21.5152 9.60998 21.515 9.60928 21.5147 9.60848C21.5143 9.60689 21.5137 9.60493 21.513 9.6026C21.5116 9.59795 21.5098 9.59184 21.5075 9.58431C21.503 9.56925 21.4966 9.54853 21.4882 9.52251C21.4716 9.47048 21.4473 9.39719 21.4146 9.3056C21.3493 9.12256 21.2503 8.8656 21.1126 8.55861C20.8378 7.94634 20.4044 7.12552 19.7678 6.29313C18.4902 4.62261 16.3673 2.87801 13.0844 2.74053L13.0216 4.23922C15.7334 4.35278 17.4816 5.77291 18.5763 7.20436C19.1258 7.92295 19.5038 8.63743 19.744 9.17271C19.8638 9.43949 19.9482 9.65937 20.0018 9.80972C20.0286 9.88483 20.0477 9.94238 20.0596 9.97951C20.0655 9.99808 20.0696 10.0115 20.072 10.0195C20.0732 10.0235 20.074 10.0261 20.0744 10.0273C20.0746 10.0278 20.0746 10.0281 20.0746 10.028C20.0746 10.0279 20.0745 10.0278 20.0745 10.0275C20.0744 10.0274 20.0744 10.0272 20.0743 10.0271C20.0743 10.0268 20.0742 10.0265 20.795 9.81934ZM13.0844 2.74053C9.80146 2.60306 7.54016 4.16407 6.12741 5.72193C5.42345 6.49818 4.92288 7.27989 4.59791 7.86704C4.43497 8.16144 4.31491 8.40923 4.23452 8.58617C4.1943 8.67471 4.16391 8.7457 4.14298 8.79616C4.13251 8.82139 4.1244 8.84151 4.11859 8.85613C4.11568 8.86344 4.11336 8.86938 4.1116 8.8739C4.11072 8.87616 4.10998 8.87807 4.10939 8.87962C4.10909 8.88039 4.10883 8.88108 4.1086 8.88167C4.10849 8.88196 4.10834 8.88234 4.10829 8.88249C4.10815 8.88284 4.10803 8.88317 4.80899 9.14991C5.50996 9.41664 5.50985 9.41692 5.50975 9.41719C5.50973 9.41725 5.50964 9.41749 5.50959 9.4176C5.5095 9.41784 5.50945 9.41798 5.50942 9.41804C5.50938 9.41816 5.50947 9.41792 5.50969 9.41734C5.51014 9.41619 5.51113 9.41365 5.51267 9.40979C5.51574 9.40206 5.52099 9.38901 5.52846 9.37101C5.5434 9.335 5.56719 9.27924 5.60018 9.20664C5.66621 9.0613 5.76871 8.84925 5.91031 8.59341C6.19442 8.08008 6.63084 7.39971 7.23855 6.72958C8.44912 5.39466 10.3098 4.12566 13.0216 4.23922L13.0844 2.74053Z"
                                                    fill="currentColor"></path>
                                                    <path d="M8.78337 9.33604C8.72981 9.40713 8.65805 9.46292 8.57443 9.49703L3.1072 11.6951C2.95672 11.7552 2.78966 11.7352 2.66427 11.6407C2.53887 11.5462 2.47359 11.3912 2.48993 11.2299L3.09576 5.36863C3.11367 5.19823 3.22102 5.04666 3.37711 4.97402C3.5331 4.9005 3.71173 4.91728 3.84442 5.01726L8.70581 8.68052C8.8385 8.78051 8.90387 8.94759 8.8762 9.1178C8.86358 9.19825 8.83082 9.27308 8.78337 9.33604" fill="currentColor"></path>
                                                </svg> 
                                            </button>

                                            <button
                                                className="btn btn-primary btn-sm"
                                                data-bs-toggle="modal"
                                                data-bs-target="#addTycModal"
                                            >
                                                <span className="btn-inner mr-5">
                                                    <svg
                                                        width="32"
                                                        height="32"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="icon-24"
                                                    >
                                                        <path
                                                            d="M12 4V20M20 12H4"
                                                            stroke="currentColor"
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                                Agregar TyC
                                            </button>
                                        </div>

                                    </div>
                                </div>

                                <div class="card-body px-0">
                                    <div class="table-responsive">
                                        <table id="user-list-table" class="table table-striped" role="grid" data-toggle="data-table">
                                            <thead>
                                                <tr class="ligth">
                                                <th>Titulo</th>
                                                <th>Region</th>
                                                <th>Ultima Actualizacion</th>
                                                <th>Estado</th>
                                                <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loadingTyc ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                                                                <div className="col-md-12 col-sm-4 mb-4">
                                                                    <div className="iq-loader-box">
                                                                        <div className="iq-loader-1"></div>
                                                                    </div>
                                                                </div>

                                                                <span className="text-muted">
                                                                    Cargando términos y condiciones...
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : tycList.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center py-4">
                                                            No hay términos y condiciones disponibles.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    tycList.map((item) => (
                                                        <tr key={item.TyC_ID}>
                                                            <td>{item.TyC_Titulo}</td>
                                                            <td>{item.Region_Nombre}</td>
                                                            <td>
                                                                {formatDateMexico(item.TyC_Act)}
                                                            </td>
                                                            <td>
                                                                <span className="badge bg-success-subtle text-success p-2">
                                                                    Activo
                                                                </span>
                                                            </td>
                                                            <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-info-subtle ms-2"
                                                                    id="viewTyCModalLabel"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#viewTycModal"
                                                                    onClick={() => handleViewTyC(item.TyC_ID)}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            className="icon-32"
                                                                            width="32"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                opacity="0.4"
                                                                                fillRule="evenodd"
                                                                                clipRule="evenodd"
                                                                                d="M17.7366 6.04606C19.4439 7.36388 20.8976 9.29455 21.9415 11.7091C22.0195 11.8924 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8924 2.05854 11.7091C4.14634 6.87903 7.86341 4 11.9902 4H12C14.0683 4 16.0293 4.71758 17.7366 6.04606ZM8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12Z"
                                                                                fill="currentColor"
                                                                            />
                                                                            <path
                                                                                d="M14.4308 11.997C14.4308 13.3255 13.3381 14.4115 12.0015 14.4115C10.6552 14.4115 9.5625 13.3255 9.5625 11.997C9.5625 11.8321 9.58201 11.678 9.61128 11.5228H9.66006C10.743 11.5228 11.621 10.6695 11.6601 9.60184C11.7674 9.58342 11.8845 9.57275 12.0015 9.57275C13.3381 9.57275 14.4308 10.6588 14.4308 11.997Z"
                                                                                fill="currentColor"
                                                                            />
                                                                        </svg>
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-warning-subtle ms-2"
                                                                    id="editTyCModalLabel"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#editTycModal"
                                                                    onClick={() => handleOpenEditTyC(item)}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            className="icon-32"
                                                                            width="32"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                opacity="0.4"
                                                                                d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z"
                                                                                fill="currentColor"
                                                                            />
                                                                            <path
                                                                                d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z"
                                                                                fill="currentColor"
                                                                            />
                                                                            <path
                                                                                opacity="0.4"
                                                                                d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z"
                                                                                fill="currentColor"
                                                                            />
                                                                        </svg>
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        {/* Modal Para Crear TyC */} 
        <div
            className="modal fade"
            id="addTycModal"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-xl modal-dialog-scrollable">
                <div className="modal-content">
                    <form onSubmit={handleCreateTyC}>
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Agregar términos y condiciones
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        <div 
                        className="modal-body"
                        style={{
                            maxHeight: "75vh",
                            overflowY: "auto",
                        }}>
                            <div className="row g-3">
                                <div className="col-md-8">
                                    <label className="form-label">Título *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={tycForm.titulo}
                                        onChange={(e) =>
                                            setTycForm({
                                                ...tycForm,
                                                titulo: e.target.value,
                                            })
                                        }
                                        placeholder="Ej. Términos y Condiciones México"
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">Región *</label>
                                    <select
                                        className="form-select"
                                        value={tycForm.regionId}
                                        onChange={(e) =>
                                            setTycForm({
                                                ...tycForm,
                                                regionId: e.target.value,
                                            })
                                        }
                                    >
                                        <option value="">Selecciona una región</option>
                                        <option value="1">México</option>
                                        <option value="2">Latinoamérica</option>
                                    </select>
                                </div>

                                <div className="col-md-12">
                                    <label className="form-label">
                                        Método de carga *
                                    </label>

                                    <div className="d-flex gap-3">
                                        <label>
                                            <input
                                                type="radio"
                                                name="tycMode"
                                                value="editor"
                                                checked={tycForm.mode === "editor"}
                                                onChange={() =>
                                                    setTycForm({
                                                        ...tycForm,
                                                        mode: "editor",
                                                        docx: null,
                                                    })
                                                }
                                            />{" "}
                                            Escribir con editor
                                        </label>

                                        <label>
                                            <input
                                                type="radio"
                                                name="tycMode"
                                                value="docx"
                                                checked={tycForm.mode === "docx"}
                                                onChange={() =>
                                                    setTycForm({
                                                        ...tycForm,
                                                        mode: "docx",
                                                        html: "",
                                                    })
                                                }
                                            />{" "}
                                            Importar documento Word
                                        </label>
                                    </div>
                                </div>

                                {tycForm.mode === "editor" && (
                                    <div className="col-md-12">
                                        <label className="form-label">
                                            Contenido *
                                        </label>

                                        <ReactQuill
                                            theme="snow"
                                            value={tycForm.html}
                                            onChange={(value) =>
                                                setTycForm({
                                                    ...tycForm,
                                                    html: value,
                                                })
                                            }
                                            modules={quillModules}
                                            formats={quillFormats}
                                            style={{
                                                minHeight: "300px",
                                                marginBottom: "50px",
                                            }}
                                        />
                                    </div>
                                )}

                                {tycForm.mode === "docx" && (
                                    <div className="col-md-12">
                                        <label className="form-label">
                                            Archivo Word (.docx) *
                                        </label>

                                        <input
                                            type="file"
                                            className="form-control"
                                            accept=".docx"
                                            onChange={(e) =>
                                                setTycForm({
                                                    ...tycForm,
                                                    docx: e.target.files[0],
                                                })
                                            }
                                        />

                                        <small className="text-muted">
                                            El backend convertirá el documento a HTML
                                            automáticamente.
                                        </small>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Cancelar
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={savingTyc}
                            >
                                {savingTyc ? "Guardando..." : "Guardar TyC"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        {/* Modal Para Ver TyC */} 
        <div
    className="modal fade"
    id="viewTycModal"
    tabIndex="-1"
    aria-hidden="true"
>
    <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">
                    Detalle de términos y condiciones
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>

            <div
                className="modal-body"
                style={{
                    maxHeight: "75vh",
                    overflowY: "auto",
                }}
            >
                {loadingTycDetail ? (
                    <p>Cargando detalle...</p>
                ) : selectedTyc ? (
                    <>
                        <div className="mb-3">
                            <h5>{selectedTyc.TyC_Titulo}</h5>
                            <p className="mb-1">
                                <strong>Región:</strong>{" "}
                                {selectedTyc.Region_Nombre}
                            </p>
                            <p className="mb-1">
                                <strong>Actualizado por:</strong>{" "}
                                {selectedTyc.Actualizado_Por_Nombre || "Sin dato"}
                            </p>
                            <p className="mb-3">
                                <strong>Fecha:</strong>{" "}
                                {formatDateMexico(selectedTyc.TyC_Act)}
                            </p>
                        </div>

                        <hr />

                        <div
                            className="tyc-preview-content"
                            dangerouslySetInnerHTML={{
                                __html: selectedTyc.TyC_HTML,
                            }}
                        />
                    </>
                ) : (
                    <p>No se encontró información.</p>
                )}
            </div>

            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                >
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>

        {/* Modal Para Editar TyC */} 
        <div
    className="modal fade"
    id="editTycModal"
    tabIndex="-1"
    aria-hidden="true"
>
    <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
            <form onSubmit={handleUpdateTyC}>
                <div className="modal-header">
                    <h5 className="modal-title">
                        Editar términos y condiciones
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div
                    className="modal-body"
                    style={{
                        maxHeight: "75vh",
                        overflowY: "auto",
                    }}
                >
                    <div className="row g-3">
                        <div className="col-md-8">
                            <label className="form-label">Título *</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editTycForm.titulo}
                                onChange={(e) =>
                                    setEditTycForm({
                                        ...editTycForm,
                                        titulo: e.target.value,
                                    })
                                }
                            />
                        </div>

                        <div className="col-md-4">
                            <label className="form-label">Región *</label>
                            <select
                                className="form-select"
                                value={editTycForm.regionId}
                                onChange={(e) =>
                                    setEditTycForm({
                                        ...editTycForm,
                                        regionId: e.target.value,
                                    })
                                }
                            >
                                <option value="">Selecciona una región</option>
                                <option value="1">México</option>
                                <option value="2">Latinoamérica</option>
                            </select>
                        </div>

                        <div className="col-md-12">
                            <label className="form-label">
                                Método de edición *
                            </label>

                            <div className="d-flex gap-3">
                                <label>
                                    <input
                                        type="radio"
                                        name="editTycMode"
                                        value="editor"
                                        checked={editTycForm.mode === "editor"}
                                        onChange={() =>
                                            setEditTycForm({
                                                ...editTycForm,
                                                mode: "editor",
                                                docx: null,
                                            })
                                        }
                                    />{" "}
                                    Editar con editor
                                </label>

                                <label>
                                    <input
                                        type="radio"
                                        name="editTycMode"
                                        value="docx"
                                        checked={editTycForm.mode === "docx"}
                                        onChange={() =>
                                            setEditTycForm({
                                                ...editTycForm,
                                                mode: "docx",
                                            })
                                        }
                                    />{" "}
                                    Reemplazar con Word
                                </label>
                            </div>
                        </div>

                        {editTycForm.mode === "editor" && (
                            <div className="col-md-12">
                                <label className="form-label">
                                    Contenido *
                                </label>

                                <ReactQuill
                                    theme="snow"
                                    value={editTycForm.html}
                                    onChange={(value) =>
                                        setEditTycForm({
                                            ...editTycForm,
                                            html: value,
                                        })
                                    }
                                    modules={quillModules}
                                    formats={quillFormats}
                                    style={{
                                        minHeight: "350px",
                                        marginBottom: "60px",
                                    }}
                                />
                            </div>
                        )}

                        {editTycForm.mode === "docx" && (
                            <div className="col-md-12">
                                <label className="form-label">
                                    Nuevo archivo Word (.docx) *
                                </label>

                                <input
                                    type="file"
                                    className="form-control"
                                    accept=".docx"
                                    onChange={(e) =>
                                        setEditTycForm({
                                            ...editTycForm,
                                            docx: e.target.files[0],
                                        })
                                    }
                                />

                                <small className="text-muted">
                                    Al guardar, el contenido actual será reemplazado
                                    por el HTML generado desde este documento.
                                </small>
                            </div>
                        )}
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Cancelar
                    </button>

                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={updatingTyc || loadingTycDetail}
                    >
                        {updatingTyc ? "Actualizando..." : "Actualizar TyC"}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

        </>
    );
}

export default HomeConfigPanel;